import React from 'react';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';

type EndTimeTrackingRequest = App.Http.Requests.TimeTracking.EndTimeTrackingRequestData;
type TimeTrackingEntry = App.Domain.TimeTracking.Data.TimeTrackingEntryData;

type EndTimeTrackingWithBarcodeFormProps = {
  timeTrackingGroupId: number;
  action: (values: EndTimeTrackingRequest) => Promise<TimeTrackingEntry>;
  onSave?: (response: TimeTrackingEntry) => void;
  onSaveAndReturn?: () => void;
  onCancel?: () => void;
};

export function EndTimeTrackingWithBarcodeForm({
  timeTrackingGroupId,
  action,
  onSave,
  onSaveAndReturn,
  onCancel,
}: EndTimeTrackingWithBarcodeFormProps) {
  const { form, fields } = useForm<EndTimeTrackingRequest, TimeTrackingEntry>({
    defaults: {
      timeTrackingGroupId,
    },
  });

  function handleSave(values: TimeTrackingEntry) {
    onSave?.(values);
    form.reset();
  }

  return (
    <Form
      action={action}
      onSave={handleSave}
      onSaveAndReturn={onSaveAndReturn}
      onCancel={onCancel}
      form={form}
      submitLabel="End"
      confirmation={{
        title: 'Time Tracking Ended',
        description: 'Tracking has been ended.',
      }}
    >
      <TextField label="Barcode" name={fields.code} required />
    </Form>
  );
}
